import React, { useEffect, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import * as termsSlice from "../../../../redux/slices/termSlice"; // Replace with actual slice for Terms and Conditions

const TermsAndCond = () => {
  const [content, setContent] = useState("");
  const editor = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { termsDetails, loading } = useSelector((state) => state.termSlice);
  console.log(termsDetails, "termsDetails");

  useEffect(() => {
    dispatch(termsSlice.getTermsDetails()); // Fetch terms by ID
  }, []);

  useEffect(() => {
    if (termsDetails) {
      setContent(termsDetails?.content || ""); // Load existing terms content
    }
  }, [termsDetails]);

  const config = {
    placeholder: "Type terms and conditions here...",
    readonly: false,
    toolbar: true,
    uploader: {
      insertImageAsBase64URI: false,
    },
  };

  const handleSave = async () => {
    await dispatch(
      termsSlice.createTerms({
        content,
      })
    );
    dispatch(termsSlice.getTermsDetails()); // Fetch terms by ID
  };

  return (
    <Container>
      <Row className="mt-4">
        <Col>
          <Button
            style={{ backgroundColor: "#e8783d", border: "none" }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
          <h1 className="text-center mt-3"> Terms and Conditions</h1>
        </Col>
      </Row>
      {false ? (
        <div className="d-flex justify-content-center mt-5">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      ) : (
        <Row className="mt-4">
          <Col>
            <JoditEditor
              ref={editor}
              value={content}
              onBlur={(newContent) => setContent(newContent)}
              config={config}
            />

            <div className="d-grid gap-2 mt-3">
              <Button variant="success" size="lg" onClick={handleSave}>
                Save
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default TermsAndCond;
